module.exports = __webpack_public_path__ + "img/20190626161421450.54a575c6.png";